export enum TrainingAttestationStatus
{
    Pending = 0,
    PastDue = 1,
    Submitted = 2,
    Verified = 3
}
